import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DateHelpers from '../../lib/DateHelpers';
import { DateTime } from 'luxon';
import { active_talents } from '../../lib/ActiveTalents';
import Talent from '../../lib/Talent.js';
import { updateUser } from '../../lib/Users';

class ActiveTalents extends React.Component {

  static adminLinkFormatter(cell, row) {
    return `<a target="_blank" href="/users/${row.swipecast_user_id}">${cell}</a>`;
  }

  static mcLinkFormatter(cell, row) {
    return `<a target="_blank" href="${row.mc_link}">${cell}</a>`;
  }

  static dateFormatter(cell) {
    if (cell) {
      return `${Math.round(DateHelpers.differenceBetweenTimeStampsInS(Date.now(), cell) / (60 * 60 * 24))} d`;
    }
    return 'N/A';
  }

  state = {
    talents: [],
  };

  componentDidMount() {
    this.getTalent('Stylist');
  }

  static transformTalentObjects = (talents) => {
    return talents.map(talent => {
      let L28Array = {}
      talent.recent_activities.forEach(activity => {
        let floorKey = Math.floor(DateTime.local().diff(DateTime.fromISO(activity.created_at)).as('days'));
        if(!L28Array[floorKey]){
          L28Array[floorKey] = 'accounted for';
        }
        talent['L28'] = Object.keys(L28Array).length;
      });
      return talent;
    })
  }


  changeDropdown = (e) => {
    this.setState({talents: []});
    this.getTalent(e.target.value);
  }
  
  getTalent = async (profile_type) => {
    const talentList = await active_talents(1000, 0, profile_type);
    const talentObjects = talentList.talents.map(talent => new Talent(talent));
    this.setState({
      talents: ActiveTalents.transformTalentObjects(talentObjects),
    });
  }

  onAfterSaveCell = (row, cellName, cellValue) => {
    updateUser(
      row.swipecast_user_id,
      { admin_notes: cellValue },
    );
  }

  render() {
    const { talents } = this.state;
    return (
      <div style={{ width: '100vw' }}>
        <select onChange={this.changeDropdown} value={this.state.value}>
          {
            ['Stylist', 'Model', 'Photographer', 'Make-up Artist'].map(category => (
              <option value={category}>{category}</option>
            ))
          }
        </select>
        <BootstrapTable
          data={talents}
          striped
          hover
          cellEdit={{
            mode: 'dbclick',
            afterSaveCell: this.onAfterSaveCell,
          }}
        >
          <TableHeaderColumn
            row="0"
            dataField="full_name"
            isKey
            dataFormat={ActiveTalents.adminLinkFormatter}
            dataAlign="center"
            dataSort
            filter={{ type: 'TextFilter', delay: 300 }}
            editable={false}
          >
              Name
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="L28"
            dataSort
            editable={false}
          >
            L28
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="features"
            dataSort
            editable={false}
          >
            Features (stuff we've enabled)
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="chat_w_matthias"
            dataSort
            editable={false}
          >
            Has had convo with Matthias
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="admin_notes"
            tdStyle={{ whiteSpace: 'normal' }}
          >
            Admin notes
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default ActiveTalents;
